import { IState } from './state.interface';
import { createSelector } from '@ngrx/store';

export const getSharedState = createSelector(
  (state: IState) => state,
  (state: IState) => state
);
